export const BUYING_TEAMS_TOTAL_ALLOWED = 25;
